import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { AttributesCodes, CampaignAdHocListItem } from '../models/lists.model';

export const PanelStatusChanged = createAction('[Campaign Lists]: Panel Status Changed');

export const NameChanged = createAction('[Campaign Lists]: Name Changed', props<{ name: string }>());

export const DescriptionChanged = createAction(
  '[Campaign Lists]: Description Changed',
  props<{ description: string }>(),
);

export const TargetChanged = createAction('[Campaign Lists]: Target Changed', props<{ target: string }>());

export const GetTargets = createAction('[Campaign Lists]: Get Targets');

export const GetTargetsSuccess = createAction('[Campaign Lists]: Get Targets Success', props<{ res: any }>());

export const GetTargetsFailed = createAction(
  '[Campaign Lists]: Get Targets Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLists = createAction('[Campaign Lists]: Get Lists');

export const GetListsSuccess = createAction(
  '[Campaign Lists]: Get Lists Success',
  props<{ res: CampaignAdHocListItem[] }>(),
);

export const GetListsFailed = createAction('[Campaign Lists]: Get Lists Failed', props<{ error: HttpErrorResponse }>());

export const ClearListsFilters = createAction('[Campaign Lists]: Clear Lists Filters');

export const DownloadList = createAction('[Campaign Lists]: Download List', props<{ data: any }>());

export const DownloadListSuccess = createAction('[Campaign Lists]: Download List Success', props<{ res: any }>());

export const DownloadListFailed = createAction(
  '[Campaign Lists]: Download List Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenConfirmDialogForDeleteList = createAction(
  '[Campaign Lists]: Open Confirm Dialog For Delete List',
  props<{ selectedRow: any }>(),
);

export const OpenDeleteListModal = createAction('[Campaign Lists]: Open Delete List Modal');

export const DeleteList = createAction('[Campaign Lists]: Delete List');

export const DeleteListSuccess = createAction('[Campaign Lists]: Delete List Success', props<{ res: any }>());

export const DeleteListFailed = createAction('[Campaign Lists]: Delete List Failed', props<{ error: any }>());

export const ShowCreateNewList = createAction('[Campaign Lists]: Show Create New List');

export const GetAttributeCodes = createAction('[Campaign Lists]: Get Attributes Codes');

export const GetAttributeCodesSuccess = createAction(
  '[Campaign Lists]: Get Attributes Codes Success',
  props<{ res: AttributesCodes[] }>(),
);

export const GetAttributeCodesFailed = createAction(
  '[Campaign Lists]: Get Attributes Codes Failed',
  props<{ error: HttpErrorResponse }>(),
);
